import { render, staticRenderFns } from "./ConnectionWarning.vue?vue&type=template&id=e5252db4&scoped=true"
import script from "./ConnectionWarning.vue?vue&type=script&lang=js"
export * from "./ConnectionWarning.vue?vue&type=script&lang=js"
import style0 from "./ConnectionWarning.vue?vue&type=style&index=0&id=e5252db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5252db4",
  null
  
)

export default component.exports